module.exports = __webpack_public_path__ + "static/media/thumb_CAMQ1880_1024.29dee270.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_CAMQ1880_1024.jpg
// module id = 132
// module chunks = 0